import Vue from 'vue'

// jQuert & Bootstrap
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery')
require('bootstrap')
require('jquery-mask-plugin')

// Axios
import axios from 'axios'
window.axios = axios

// Moment Js
import moment from 'moment-timezone'
window.moment = moment
window.clientTimeZone = moment.tz.guess();
Vue.prototype.$moment = window.moment;

// Lodash
import lodash from 'lodash'
window._ = lodash

// intlTelInput (Phone)
import intlTelInput from 'intl-tel-input'
window.intlTelInput = intlTelInput

// Flatpicker (Calendar)
import flatpickr from 'flatpickr'
window.flatpickr = flatpickr

// Pluralize strings
window.pluralize = require('pluralize')

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect)

